import { render, staticRenderFns } from "./Homestay.vue?vue&type=template&id=53b2ceb8&scoped=true&"
import script from "./Homestay.vue?vue&type=script&lang=js&"
export * from "./Homestay.vue?vue&type=script&lang=js&"
import style0 from "./Homestay.vue?vue&type=style&index=0&id=53b2ceb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2ceb8",
  null
  
)

export default component.exports